var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"richTextEditorWrapper"},[(_vm.showEditor)?_c('editor',{attrs:{"api-key":"","init":_vm.editorConfig},on:{"input":_vm.updateValue},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}):_c('b-spinner',{staticClass:"align-middle"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }